import { KsService } from '@siclop/kstone-vue'

export class EmployeeScheduleService extends KsService {
  protected static mainUrl = '/employee-schedules'
}
